

import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { Sample } from './sample';
import { SampleView } from './sample-view';

import { SampleRequest } from './form';

const localKey = "cart.mgsl.uri.edu"
function saveCart(cart: any) {
    localStorage.setItem(localKey, JSON.stringify(cart))
}
function getCart() {
    return JSON.parse(localStorage.getItem(localKey)!);
}

@customElement('sample-cart')
export class SampleCart extends LitElement {

    static styles = css`
:host {
   position: relative;
   display: flex;
   flex-flow: column nowrap;
   flex: 1 1 auto;
   min-height: 25%;
   border-radius: 0.2em;
}
.cart-list {
    display: flex;
    flex-flow: column nowrap;
    overflow: scroll;
    padding-right: 1em;
}
.cart-buttons {
    position: relative;
    margin-left: auto;
    display: flex;
    flex-flow: row nowrap;
}
.cart-buttons div {
    cursor: pointer;
    padding: 0.2em;
    margin-left: 0.2em;
    margin-right: 0.2em;
    margin-bottom: 0.2em;
    border: 1px solid #ffffff50;
    border-radius: 0.3em;
}
.cart-buttons div:hover {
    background: #00000050;
}
.cart-title {
padding-top: 0.5em;
padding-top: 0.2em;
    margin-left: 0.0em;
    margin-right: 0.2em;
    border: 1px solid rgba(0,0,0,0);
font-size: 1.2em;
font-weight: bold;
}
.cart-header {
    display: flex;
    flex-flow: row nowrap;
    border-bottom: 1px solid #ddd;
    margin-right: 1em;
}
`;

    @property({ type: Array })
    items: Sample[];


    constructor() {
        super();
        this.items = [];
        const data = getCart();
        if (data && data.items && data.items.length)
            this.items = [...data.items];
        this.addEventListener('cart-action', (ev: Event) => {
            const sample = (ev as CustomEvent).detail;
            if (this.has(sample))
                this.rm(sample)
            else
                this.add(sample);
        });
        document.querySelector('body')!.addEventListener('form-cancel', (_ev: Event) => {
            document.querySelector('#form')!.remove();
        });
    }

    size() {
        return this.items.length
    }

    has(sample: Sample) {
        return this.items.some(z => z.Full_Sample_Name == sample.Full_Sample_Name);
    }

    add(sample: Sample) {
        if (this.has(sample))
            return
        this.items = [...this.items, sample];
        saveCart({ items: this.items })
        this.dispatchEvent(this.event('cart-item-add', sample));
    }

    rm(sample: Sample) {
        this.items = this.items.filter(z => z.Full_Sample_Name != sample.Full_Sample_Name);
        saveCart({ items: this.items })
        this.dispatchEvent(this.event('cart-item-remove', sample));
    }

    clear() {
        if (!window.confirm("Do you want to clear all items from your cart?")) {
            return;
        }
        this.items.forEach(item => this.rm(item));
        saveCart({ items: this.items })
    }

    submit(_ev: Event) {
        const form = document.createElement('form');
        form.classList.add('form');
        form.id = 'form';
        const req = new SampleRequest(this.items);
        form.appendChild(req);
        document.querySelector('body')!.appendChild(form);
    }

    event(name: string, sample: Sample) {
        return new CustomEvent(name, { bubbles: true, composed: true, detail: sample })
    }

    cart_items() {
        return this.items.map(item => new SampleView(item, true, item.sub_sample_id !== undefined));
    }


    render() {
        const n = this.items.length;
        return html`
<link rel="stylesheet" href="font-awesome-4.7.0/css/font-awesome.min.css">
<div class="cart-header">
  <div class="cart-title">Sample Cart</div>
  <div class="cart-buttons" style="${(n == 0) ? 'display: none' : ''}">
     <div class="cart-clear" title="Clear cart" @click=${this.clear}>Clear</div>
     <div class="cart-submit" title="Submit cart" @click=${this.submit}>Submit</div>
  </div>
</div>
<div class="cart-list">${this.cart_items()}</div>
`
    }
}
